import { ReactNode } from 'react';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { css } from '@emotion/react';

import { visuallyHidden } from '@atlaskit/theme';

export const srOnlyStyles = css(visuallyHidden());

// Only display content to screen readers
// See README for more information

export const ScreenReadersOnly = (props: { children: ReactNode }) => (
  <span css={srOnlyStyles} {...props}>
    {props.children}
  </span>
);
